import React, { Component } from 'react';
import * as styled from '../../styles/style';
import { userActions } from '../../actions/users';
import { Link } from 'react-router-dom';
import Notification from '../Notification';

class ResetPassword extends Component {

	constructor(props) {
		super(props);

		const { match } = this.props;
		this.state = {
			email: '',
		}

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event) {
    this.setState({ 
    	[event.target.name]: event.target.value 
    });
  }

	handleSubmit(event) {
    event.preventDefault();
    return this.props.resetPassword(this.state.email);
  }

  render() {
  	return (
      <styled.Main>
      	<Notification type={this.props.alertType} message={this.props.alertMessage} />
        <form onSubmit={this.handleSubmit}>
          <styled.Heading>Reset Password</styled.Heading>
          <styled.Hint>Enter the email address you used to register, and we will send you an email with further instructions. Need more help? Just write to <a href="mailto:hosts@onthetablebc.com">hosts@onthetablebc.com</a>.</styled.Hint>
	        <styled.FormRow>
	          <styled.FullWidthFieldGroup>
	            <styled.Label htmlFor="email">Email</styled.Label>
	            <styled.FormField public id="email" name="email" value={this.state.email} onChange={this.handleChange} />
	          </styled.FullWidthFieldGroup>
	        </styled.FormRow>
          <styled.ButtonGroup>
            <styled.ButtonLink secondary="true" to="/host/signin">&lt; Go back</styled.ButtonLink>
  	        <styled.Button type="submit" value='Reset' />
          </styled.ButtonGroup>
	      </form>
      </styled.Main>
    )
  }
}

export default ResetPassword
